(function() {
  'use strict';

  class SmartGallery extends HTMLElement {
    constructor() {
      super();
      this.maxH = parseInt(this.dataset.maxHeight) || 420;
      this.hGap = parseInt(this.dataset.hGap) || 16;
      this.vGap = parseInt(this.dataset.vGap) || 24;
      /* 0 = the original pairs layout below. A number = fixed rows of that many (_rows). */
      this.perRow = parseInt(this.dataset.perRow) || 0;
    }

    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('.sg-item'));
      this._items.forEach(function(item) {
        item._ar = parseFloat(item.dataset.aspectRatio) || 1;
        item._isH = item._ar > 1;
      });
      var self = this;
      self._layout();
      var t;
      window.addEventListener('resize', function() {
        clearTimeout(t);
        t = setTimeout(function() { self._layout(); }, 200);
      });
    }

    _layout() {
      var grid = this.querySelector('.sg-grid');
      if (!grid || !this._items.length) return;

      /* Measure content width BEFORE clearing — grid collapses to 0 when empty
         because custom elements default to display:inline. Belt-and-suspenders. */
      var cs = window.getComputedStyle(grid);
      var W = grid.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);

      this._items.forEach(function(item) {
        item.style.cssText = '';
        var ic = item.querySelector('.sg-item__image');
        if (ic) ic.style.cssText = '';
      });

      grid.innerHTML = '';

      if (window.innerWidth < 750) {
        this._mobile(grid);
        return;
      }

      if (W <= 0) {
        /* Fallback: measure parent */
        var p = grid.parentElement;
        while (p && p.offsetWidth === 0) p = p.parentElement;
        W = p ? p.offsetWidth : 760;
        var gridCS = window.getComputedStyle(grid);
        var maxW = parseFloat(gridCS.maxWidth);
        if (maxW && W > maxW) W = maxW;
        W = W - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      }

      var hG = this.hGap;
      var vG = this.vGap;
      var maxH = this.maxH;

      if (this.perRow) {
        this._rows(grid, W, hG, vG, maxH);
        return;
      }

      var rows = this._group();

      for (var r = 0; r < rows.length; r++) {
        var row = rows[r];
        var el = document.createElement('div');
        el.className = 'sg-row sg-row--' + row.type;
        el.style.gap = hG + 'px';
        el.style.justifyContent = 'center';
        if (r > 0) el.style.marginTop = vG + 'px';

        switch (row.type) {
          case '2h': case '2v': case 'mixed':
            this._pair(el, row.items, W, hG, maxH); break;
          case 'v2h':
            this._tripleV2H(el, row.items, W, hG, vG, maxH); break;
          case 'solo-h':
            this._solo(el, row.items[0], 0.60, W, maxH); break;
          case 'solo-v':
            this._solo(el, row.items[0], 0.35, W, maxH); break;
        }
        grid.appendChild(el);
      }
    }

    _group() {
      var items = this._items, rows = [], i = 0;
      while (i < items.length) {
        var c = items[i], n1 = items[i+1], n2 = items[i+2];
        if (c._isH) {
          if (n1 && n1._isH) { rows.push({type:'2h',items:[c,n1]}); i+=2; }
          else if (n1) { rows.push({type:'mixed',items:[c,n1]}); i+=2; }
          else { rows.push({type:'solo-h',items:[c]}); i+=1; }
        } else {
          if (n1 && !n1._isH) { rows.push({type:'2v',items:[c,n1]}); i+=2; }
          else if (n1 && n1._isH && n2 && n2._isH) { rows.push({type:'v2h',items:[c,n1,n2]}); i+=3; }
          else if (n1) { rows.push({type:'mixed',items:[c,n1]}); i+=2; }
          else { rows.push({type:'solo-v',items:[c]}); i+=1; }
        }
      }
      return rows;
    }

    _setImg(item, w, h) {
      item.style.width = Math.round(w) + 'px';
      item.style.flex = 'none';
      var ic = item.querySelector('.sg-item__image');
      if (ic) ic.style.height = Math.round(h) + 'px';
    }

    _pair(el, items, W, G, maxH) {
      var a1 = items[0]._ar, a2 = items[1]._ar;
      var H = (W - G) / (a1 + a2);
      if (H > maxH) H = maxH;
      this._setImg(items[0], H * a1, H);
      this._setImg(items[1], H * a2, H);
      el.appendChild(items[0]);
      el.appendChild(items[1]);
    }

    _tripleV2H(el, items, W, hG, vG, maxH) {
      var vAR = items[0]._ar, h1AR = items[1]._ar, h2AR = items[2]._ar;
      var invSum = (1/h1AR) + (1/h2AR);
      var S = (W - hG*(vAR+1)) / (vAR*invSum + 1);
      var H = S * invSum + vG;
      if (H > maxH) { H = maxH; S = (H - vG) / invSum; }

      var vW = H * vAR;
      var s1H = S / h1AR;
      var s2H = S / h2AR;

      this._setImg(items[0], vW, H);
      el.appendChild(items[0]);

      var stack = document.createElement('div');
      stack.className = 'sg-stacked';
      stack.style.width = Math.round(S) + 'px';
      stack.style.gap = vG + 'px';

      this._setImg(items[1], S, s1H);
      this._setImg(items[2], S, s2H);
      stack.appendChild(items[1]);
      stack.appendChild(items[2]);
      el.appendChild(stack);
    }

    /* FIXED ROWS — added 2026-10-30 for the Sky Study rework (board c41). Phil, 27 Oct: three
       prints in a line "made me just feel powerful", and mixed portrait/landscape in one row is
       fine ("so be it"). Every photo in a row gets ONE height and the row fills the width, so a
       portrait simply takes less of it.
       NO PHOTO ALONE ON A ROW (30 Oct, Shane, on Vantage's 3 + 1: "since there are four we can
       easily even it out two and two centred. Keep them the same size."). If the last row would
       hold one photo, the row above gives it a partner: 4 = 2 + 2, 7 = 3 + 2 + 2. A short row is
       never enlarged to fill the line: every row is sized as if it were a full row of n (its own
       average shape, n across), then centred. For a full row that is the same sum as before.
       Under 900px of grid width three get too small, so it drops to two. maxH still caps a row of
       portraits, which would otherwise come out taller than the screen.
       W - 1: the widths are rounded, and three roundings up must never add up past the line. */
    _rows(grid, W, hG, vG, maxH) {
      var n = W < 900 ? Math.min(2, this.perRow) : this.perRow;
      var items = this._items, counts = [], left = items.length;
      while (left > 0) { counts.push(Math.min(n, left)); left -= n; }
      var k = counts.length;
      if (n >= 3 && k > 1 && counts[k - 1] === 1) { counts[k - 2]--; counts[k - 1]++; }
      for (var i = 0, r = 0; r < k; i += counts[r], r++) {
        var row = items.slice(i, i + counts[r]), sum = 0, j;
        for (j = 0; j < row.length; j++) sum += row[j]._ar;
        var H = Math.min((W - 1 - hG * (n - 1)) / (n * sum / row.length), maxH);

        var el = document.createElement('div');
        el.className = 'sg-row sg-row--fixed';
        el.style.gap = hG + 'px';
        el.style.justifyContent = 'center';
        if (r > 0) el.style.marginTop = vG + 'px';
        for (j = 0; j < row.length; j++) {
          this._setImg(row[j], H * row[j]._ar, H);
          el.appendChild(row[j]);
        }
        grid.appendChild(el);
      }
    }

    _solo(el, item, frac, W, maxH) {
      var w = W * frac;
      var h = w / item._ar;
      if (h > maxH) { h = maxH; w = h * item._ar; }
      this._setImg(item, w, h);
      el.appendChild(item);
    }

    _mobile(grid) {
      this._items.forEach(function(item) {
        item.style.cssText = '';
        var ic = item.querySelector('.sg-item__image');
        if (ic) ic.style.cssText = '';
        grid.appendChild(item);
      });
    }
  }

  if (!customElements.get('smart-gallery')) {
    customElements.define('smart-gallery', SmartGallery);
  }
})();
